import { ApiPaths } from 'api/constants';
import { ProcessGeneral } from 'api/endpoints/processes';
import { ProcessVersionGeneral } from 'api/endpoints/processVersions';
import ApiUrlParams from 'constants/apiUrlParams';
import { ApiResponseAsync } from 'container/models';

import BaseRepo from '../../BaseRepo';
import {
  EmailTemplate,
  EmailTemplateBase,
  IEmailTemplateRepo,
  IsUsedInfo,
} from './IEmailTemplateRepo';

export class EmailTemplateRepo extends BaseRepo implements IEmailTemplateRepo {
  createEmailTemplate = (
    draft: ProcessGeneral,
    emailTemplate: EmailTemplateBase
  ): ApiResponseAsync<EmailTemplate> => {
    const url = ApiPaths.processes.byId.emailTemplates._({
      [ApiUrlParams.releaseOrDraftProcessId]: draft.id,
    });
    return this.helpers.handlePost(url, emailTemplate);
  };

  deleteEmailTemplate = (
    draft: ProcessGeneral,
    emailTemplate: EmailTemplate
  ): ApiResponseAsync<void> => {
    const url = ApiPaths.processes.byId.emailTemplates.byId._({
      [ApiUrlParams.releaseOrDraftProcessId]: draft.id,
      [ApiUrlParams.emailTemplateId]: emailTemplate.id,
    });
    return this.helpers.handleDelete(url);
  };

  getEmailTemplateDetails = (
    draft: ProcessGeneral,
    emailTemplateId: string
  ): ApiResponseAsync<EmailTemplate> => {
    const url = ApiPaths.processes.byId.emailTemplates.byId._({
      [ApiUrlParams.releaseOrDraftProcessId]: draft.id,
      [ApiUrlParams.emailTemplateId]: emailTemplateId,
    });
    return this.helpers.handleGet(url);
  };

  getEmailTemplateIsUsed = (
    draft: ProcessGeneral,
    emailTemplateId: string
  ): ApiResponseAsync<IsUsedInfo> => {
    const url = ApiPaths.processes.byId.emailTemplates.byId.isUsed._({
      [ApiUrlParams.releaseOrDraftProcessId]: draft.id,
      [ApiUrlParams.emailTemplateId]: emailTemplateId,
    });
    return this.helpers.handleGet(url);
  };

  getEmailTemplateList = (
    draftOrRelease: ProcessGeneral | ProcessVersionGeneral
  ): ApiResponseAsync<DataWithTotal<EmailTemplate>> => {
    const url = ApiPaths.processes.byId.emailTemplates._({
      [ApiUrlParams.releaseOrDraftProcessId]:
        'releaseId' in draftOrRelease
          ? draftOrRelease.releaseId
          : draftOrRelease.id,
    });
    return this.helpers.handleGet<DataWithTotal<EmailTemplate>>(url);
  };

  updateEmailTemplate = (
    draft: ProcessGeneral,
    emailTemplate: EmailTemplate
  ): ApiResponseAsync<EmailTemplate> => {
    const url = ApiPaths.processes.byId.emailTemplates.byId._({
      [ApiUrlParams.releaseOrDraftProcessId]: draft.id,
      [ApiUrlParams.emailTemplateId]: emailTemplate.id,
    });
    return this.helpers.handlePut(url, emailTemplate);
  };
}
